import {Model} from "mobx-rest/lib";

class _cancelJobs extends Model {
    url() {
        return '/policyJobs';
    }
}

export class cancelJobs extends Model {
    url() {
        return '/policyJobs/cancelJobs';
    }

    save(attributes, options) {
        const _cancelJobsModel = new _cancelJobs()
        return _cancelJobsModel.rpc('cancelJobs', Array.from(this.attributes.values()))
    }
}